import { useZodForm } from '../../../hooks/useZodForm.ts';
import { schOrderDetailsForm } from '../schemas.ts';

export const useOrderDetailsForm = () =>
  useZodForm({
    schema: schOrderDetailsForm,
    mode: 'onBlur',
    reValidateMode: 'onBlur',
    defaultValues: {},
    shouldFocusError: false, // Prevent focus jumping on validation errors
  });
